import React from "react";
import { bool, func } from "prop-types";
import classNames from "classnames";

class ToggleSidebar extends React.Component {
    static propTypes = {
        isSidebarCollapsed: bool.isRequired,
        onToggle: func.isRequired,
    };

    render() {
        const { isSidebarCollapsed, onToggle } = this.props;
        return (
            <button
                type="button"
                className={classNames("navbar-hamburger btn", {
                    collapsed: isSidebarCollapsed,
                })}
                onClick={onToggle}
            />
        );
    }
}

export default ToggleSidebar;
